// extracted by mini-css-extract-plugin
module.exports = {"container":"cookie-policy-section_container__F329G","title":"cookie-policy-section_title__TSUMQ"};